import { render } from "./Reports.vue?vue&type=template&id=7946ec84&scoped=true"
import script from "./Reports.vue?vue&type=script&lang=js"
export * from "./Reports.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-7946ec84"

export default script